import api from 'api';
import {useQuery} from 'react-query';
import {RouteTrackingDetails} from 'types/route-tracking';

export const fetchRouteTrackingFn = async (id: string) => {
  const {data} = await api.get<RouteTrackingDetails>(`/routes/track/${id}`);
  return data;
};

export const useRouteTracking = ({id}: {id: string}) =>
  useQuery({
    queryFn: () => fetchRouteTrackingFn(id),
    queryKey: ['route-tracking', id],
    enabled: !!id,
    refetchOnWindowFocus: true,
  });
